(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-article"]) return;
  try {
    
  if (!customElements.get('sv-toc')) {
    customElements.define(
      'sv-toc',
      class extends HTMLElement {
        connectedCallback() {
          const list = document.getElementById(this.dataset.target);
          const source = document.querySelector('[data-toc-source]');
          if (!list || !source) return;
          const headings = [...source.querySelectorAll('h2')];
          if (headings.length < 2) return;
          headings.forEach((h, i) => {
            if (!h.id) {
              const slug = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
              h.id = slug || `sectie-${i + 1}`;
            }
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = `#${h.id}`;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            list.appendChild(li);
          });
          this.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-bundle')) {
    customElements.define(
      'sv-bundle',
      class SvBundle extends HTMLElement {
        connectedCallback() {
          this.vat = parseFloat(this.dataset.vat) || 121;
          this.money = new Intl.NumberFormat(this.dataset.locale || 'nl', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          });
          try {
            this.main = JSON.parse(this.querySelector('[data-main-json]').textContent);
          } catch (e) {
            this.main = { id: null, variants: [] };
          }
          this.mainCheck = this.querySelector('[data-main]');
          this.buildTabs();
          this.addEventListener('change', (e) => this.onChange(e));
          this.addEventListener('click', (e) => this.onClick(e));
          this.querySelector('[data-add]').addEventListener('click', () => this.addToCart());
          this.querySelector('[data-quote]').addEventListener('click', (e) => this.toQuote(e));
          document.addEventListener('change', (e) => {
            if (e.target.closest && !this.contains(e.target)) requestAnimationFrame(() => this.render());
          });
          this.render();
        }

        buildTabs() {
          const list = this.querySelector('[data-tabs]');
          const panels = [...this.querySelectorAll('[data-tab-panel]')];
          panels.forEach((panel, i) => {
            const id = `${this.id}-tab-${i}`;
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'sv-bundle__tab';
            btn.id = id;
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-controls', `${id}-panel`);
            btn.innerHTML = `<span>${panel.dataset.label}</span><span class="sv-bundle__tab-count" hidden></span>`;
            btn.addEventListener('click', () => this.selectTab(i));
            btn.addEventListener('keydown', (e) => {
              if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                e.preventDefault();
                const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + panels.length) % panels.length;
                this.selectTab(next, true);
              }
            });
            list.appendChild(btn);
            panel.id = `${id}-panel`;
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', id);
          });
          if (panels.length < 2) list.hidden = true;
          this.selectTab(0);
        }

        selectTab(index, focus = false) {
          const tabs = [...this.querySelectorAll('.sv-bundle__tab')];
          const panels = [...this.querySelectorAll('[data-tab-panel]')];
          tabs.forEach((t, i) => {
            t.setAttribute('aria-selected', String(i === index));
            t.tabIndex = i === index ? 0 : -1;
            if (i === index && focus) t.focus();
          });
          panels.forEach((p, i) => (p.hidden = i !== index));
        }

        onClick(e) {
          const step = e.target.closest('[data-step]');
          if (!step) return;
          const row = step.closest('[data-row]');
          const input = row.querySelector('[data-qty]');
          const next = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10)));
          input.value = next;
          row.querySelector('[data-pick]').checked = true;
          this.render();
        }

        onChange() {
          this.render();
        }

        currentMainVariant() {
          const input = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
          const id = input && !this.contains(input) ? parseInt(input.value, 10) : this.main.id;
          return this.main.variants.find((v) => v.id === id) || this.main.variants.find((v) => v.id === this.main.id);
        }

        selection() {
          const items = [];
          const main = this.currentMainVariant();
          if (this.mainCheck.checked && main) {
            items.push({
              id: main.id,
              quantity: 1,
              price: main.price,
              title: this.main.title,
              sku: main.sku,
              variantTitle: this.main.variants.length > 1 ? main.title : '',
              url: this.main.url,
              image: this.main.image,
            });
          }
          this.querySelectorAll('[data-row]').forEach((row) => {
            const pick = row.querySelector('[data-pick]');
            row.classList.toggle('is-picked', pick.checked);
            if (!pick.checked) return;
            const select = row.querySelector('[data-variant]');
            const opt = select ? select.selectedOptions[0] : row;
            const qty = parseInt(row.querySelector('[data-qty]').value, 10) || 1;
            items.push({
              id: parseInt(opt.dataset.variantId || select?.value, 10),
              quantity: qty,
              price: parseInt(opt.dataset.price, 10),
              title: row.dataset.title,
              sku: opt.dataset.sku || '',
              variantTitle: select ? opt.dataset.title || '' : '',
              url: row.dataset.url || '',
              image: row.dataset.image || '',
              row,
            });
          });
          return items;
        }

        render() {
          const items = this.selection();
          const main = this.currentMainVariant();
          const variantEl = this.querySelector('[data-main-variant]');
          if (variantEl && main && this.main.variants.length > 1) variantEl.textContent = main.title;

          const picked = this.querySelector('[data-picked]');
          picked.innerHTML = '';
          items.filter((i) => i.row).forEach((i) => {
            const li = document.createElement('li');
            li.innerHTML = `<span>${i.quantity}× ${i.title}</span><span>${this.fmt((i.price * i.quantity * 100) / this.vat)}</span>`;
            picked.appendChild(li);
          });
          this.querySelector('[data-hint]').hidden = items.some((i) => i.row);

          const total = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
          const count = items.reduce((sum, i) => sum + i.quantity, 0);
          this.querySelector('[data-total]').textContent = this.fmt((total * 100) / this.vat);
          this.querySelector('[data-total-incl]').textContent = `excl. BTW · ${this.fmt(total)} incl. BTW`;
          this.querySelector('[data-count]').textContent = count === 1 ? '1 artikel' : `${count} artikelen`;
          this.querySelector('[data-add]').disabled = count === 0;

          const panels = [...this.querySelectorAll('[data-tab-panel]')];
          this.querySelectorAll('.sv-bundle__tab').forEach((tab, idx) => {
            const n = panels[idx].querySelectorAll('[data-pick]:checked').length;
            const badge = tab.querySelector('.sv-bundle__tab-count');
            badge.hidden = n === 0;
            badge.textContent = n;
          });
        }

        fmt(cents) {
          return this.money.format(Math.round(cents) / 100);
        }

        async addToCart() {
          const btn = this.querySelector('[data-add]');
          const error = this.querySelector('[data-error]');
          const items = this.selection().map(({ id, quantity }) => ({ id, quantity }));
          if (!items.length) return;
          btn.disabled = true;
          btn.classList.add('is-loading');
          error.hidden = true;
          try {
            const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.description || data.message || 'Toevoegen mislukt');
            window.location.href = this.dataset.cartUrl;
          } catch (e) {
            error.textContent = e.message;
            error.hidden = false;
            btn.disabled = false;
            btn.classList.remove('is-loading');
          }
        }

        toQuote(e) {
          const items = this.selection();
          if (!items.length) return;
          e.preventDefault();
          if (window.SvQuote) {
            window.SvQuote.add(
              items.map((i) => ({
                id: i.id,
                qty: i.quantity,
                product: i.title,
                variant: i.variantTitle || '',
                sku: i.sku || '',
                url: i.url || '',
                image: i.image || '',
                price: i.price,
              })),
              { open: true }
            );
            return;
          }
          const products = items.map((i) => `${i.quantity}x ${i.title}`).join(', ');
          const skus = items.map((i) => i.sku).filter(Boolean).join(', ');
          const url = new URL(this.dataset.quoteUrl, window.location.origin);
          url.searchParams.set('product', products);
          if (skus) url.searchParams.set('sku', skus);
          url.hash = 'offerte-formulier';
          window.location.href = url.toString();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-cat-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-rail')) {
    customElements.define(
      'sv-rail',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-rail-track]');
          this.prev = this.querySelector('[data-rail-prev]');
          this.next = this.querySelector('[data-rail-next]');
          if (!this.track) return;
          const step = (dir) => {
            const amount = Math.max(this.track.clientWidth * 0.8, 200);
            this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
          };
          this.prev?.addEventListener('click', () => step(-1));
          this.next?.addEventListener('click', () => step(1));
          this.update = () => {
            const max = this.track.scrollWidth - this.track.clientWidth - 2;
            if (this.prev) this.prev.hidden = this.track.scrollLeft <= 2;
            if (this.next) this.next.hidden = this.track.scrollLeft >= max;
          };
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.track);
          this.update();
        }
        disconnectedCallback() {
          this.ro?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-configurator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const nl = (n) => String(Math.round(n * 100) / 100).replace('.', ',');
    const money = (cents) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);

    const init = (root) => {
      if (root.dataset.svReady) return;
      const dataEl = root.querySelector('[data-sv-conf-data]');
      if (!dataEl) return;
      root.dataset.svReady = '1';
      let data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const products = data.products || [];
      const factor = 1 + (Number(data.vat) || 21) / 100;
      const excl = (c) => (data.incl ? c / factor : c);
      const inclP = (c) => (data.incl ? c : c * factor);

      const form = root.querySelector('[data-sv-conf-form]');
      const steps = [...root.querySelectorAll('.sv-conf__step')];
      const back = root.querySelector('[data-sv-conf-back]');
      const bar = root.querySelector('[data-sv-conf-bar]');
      const stepnum = root.querySelector('[data-sv-conf-stepnum]');
      const result = root.querySelector('[data-sv-conf-result]');
      const progress = root.querySelector('[data-sv-conf-progress]');
      let current = 0;

      // Height options from the data: whole metres that exist in the collection.
      const heights = [...new Set(products.map((p) => Math.floor(p.wh)))].sort((a, b) => a - b);
      const hWrap = root.querySelector('[data-sv-conf-heights]');
      hWrap.innerHTML = heights.map((h) => `<label class="sv-conf__opt sv-conf__opt--chip"><input type="radio" name="height" value="${h}"><span class="sv-conf__opt-body"><strong>${h} m</strong></span></label>`).join('');

      const show = (i) => {
        current = i;
        steps.forEach((s, n) => { s.hidden = n !== i; });
        back.hidden = i === 0;
        bar.style.width = `${((i) / steps.length) * 100}%`;
        stepnum.textContent = `Stap ${i + 1} van ${steps.length}`;
        result.hidden = true;
        form.hidden = false;
        progress.hidden = false;
      };

      const val = (name) => form.elements[name]?.value || '';

      const score = (p, a) => {
        let s = 0;
        const why = [];
        if (a.width !== 'any' && p.w) {
          if (p.w === Number(a.width)) { s += 4; why.push(`${p.w} cm breed`); } else s -= Math.abs(p.w - Number(a.width)) / 20;
        }
        if (a.length !== 'any' && p.len) {
          if (Math.abs(p.len - Number(a.length)) < 0.01) { s += 3; why.push(`platform ${nl(p.len)} m`); } else s -= 1.5;
        }
        const plat = (p.plat + ' ' + p.uitv).toLowerCase();
        if (a.build === 'hout') { if (plat.includes('hout')) { s += 3; why.push('houten platform'); } else s -= 1; }
        if (a.build === 'licht') { if (plat.includes('licht')) { s += 3; why.push('lichtgewicht platform'); } else s -= 1; }
        if (a.build === 'voorloop') { if (plat.includes('voorloop')) { s += 4; why.push('voorloopleuning'); } else s -= 2; }
        const prof = p.toep.toLowerCase().includes('professioneel gebruik');
        if (a.use === 'professioneel') { if (prof) { s += 3; why.push('voor professioneel gebruik'); } }
        if (a.use === 'particulier' && !prof) { s += 1; }
        return { s, why };
      };

      const recommend = () => {
        const a = { use: val('use'), height: Number(val('height')), width: val('width') || 'any', length: val('length') || 'any', build: val('build') || 'any' };
        let pool = products.filter((p) => p.wh >= a.height - 0.01);
        let note = '';
        if (!pool.length) {
          const max = Math.max(...products.map((p) => p.wh));
          pool = products.filter((p) => p.wh === max);
          note = `Zo hoog gaat ons standaardassortiment niet. Dit zijn de hoogste rolsteigers; bel ons voor een oplossing op maat.`;
        }
        const minWh = Math.min(...pool.map((p) => p.wh));
        const ranked = pool.map((p) => {
          const r = score(p, a);
          return { p, s: r.s - (p.wh - minWh) * 3, why: r.why };
        }).sort((x, y) => y.s - x.s || x.p.p - y.p.p);

        const picks = [];
        const best = ranked[0];
        if (best) picks.push({ ...best, label: data.labels.best });
        const rest = ranked.slice(1);
        const cheap = rest.filter((r) => r.p.p < best.p.p && r.s >= best.s - 4).sort((x, y) => x.p.p - y.p.p)[0];
        if (cheap) picks.push({ ...cheap, label: data.labels.cheap });
        const third = rest.find((r) => !picks.some((k) => k.p.id === r.p.id));
        if (third) picks.push({ ...third, label: third.p.p > best.p.p ? data.labels.comfort : data.labels.alt });
        if (picks.length < 3) {
          rest.filter((r) => !picks.some((k) => k.p.id === r.p.id)).slice(0, 3 - picks.length).forEach((r) => picks.push({ ...r, label: data.labels.alt }));
        }
        if (!note && best && best.why.length < [a.width, a.length, a.build].filter((x) => x !== 'any').length) {
          note = 'Niet elke combinatie bestaat. We tonen de rolsteigers die het dichtst bij je wensen komen.';
        }
        return { a, picks, note };
      };

      const labelsFor = (a) => {
        const out = [];
        out.push(a.use === 'professioneel' ? 'Professioneel' : 'Klussen rond huis');
        out.push(`Minimaal ${a.height} m werkhoogte`);
        out.push(a.width === 'any' ? 'Breedte: geen voorkeur' : `${a.width} cm breed`);
        out.push(a.length === 'any' ? 'Lengte: geen voorkeur' : `Platform ${nl(Number(a.length))} m`);
        out.push({ hout: 'Houten platform', licht: 'Lichtgewicht platform', voorloop: 'Voorloopleuning', any: 'Platform: geen voorkeur' }[a.build]);
        return out;
      };

      const card = (r, i) => {
        const p = r.p;
        const quote = JSON.stringify({ id: p.id, product: p.t, variant: '', sku: p.sku, url: p.u, image: p.th, price: p.p });
        const why = [`${nl(p.wh)} m werkhoogte`, ...r.why.filter((w) => !w.includes('werkhoogte'))];
        return `<li class="sv-conf__res${i === 0 ? ' is-best' : ''}">
          <span class="sv-conf__label">${esc(r.label)}</span>
          <a class="sv-conf__img" href="${esc(p.u)}">${p.img ? `<img src="${esc(p.img)}" alt="${esc(p.t)}" loading="lazy" width="480" height="480">` : ''}</a>
          <div class="sv-conf__info">
            <p class="sv-conf__vendor">${esc(p.v)}</p>
            <h3 class="sv-conf__name"><a href="${esc(p.u)}">${esc(p.t)}</a></h3>
            <ul class="sv-conf__why list-unstyled" role="list">${why.map((w) => `<li>${esc(w)}</li>`).join('')}</ul>
            <p class="sv-conf__price"><strong>${money(excl(p.p))}</strong> <span>excl. BTW</span><small>${money(inclP(p.p))} incl. BTW</small></p>
            <div class="sv-conf__btns">
              <form method="post" action="/cart/add"><input type="hidden" name="id" value="${p.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="sv-btn">In winkelwagen</button></form>
              <button type="button" class="sv-btn sv-btn--ghost" data-sv-quote-add data-sv-quote-item="${esc(quote)}">Voeg toe aan offerte</button>
            </div>
            <a class="sv-link sv-conf__view" href="${esc(p.u)}">Bekijk product →</a>
          </div>
        </li>`;
      };

      const finish = () => {
        const { a, picks, note } = recommend();
        root.querySelector('[data-sv-conf-summary]').innerHTML = labelsFor(a).map((l) => `<li>${esc(l)}</li>`).join('');
        const noteEl = root.querySelector('[data-sv-conf-note]');
        noteEl.hidden = !note;
        noteEl.textContent = note;
        root.querySelector('[data-sv-conf-results]').innerHTML = picks.map(card).join('');
        form.hidden = true;
        progress.hidden = true;
        result.hidden = false;
        result.focus({ preventScroll: true });
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      form.addEventListener('change', (e) => {
        if (e.target.type !== 'radio') return;
        setTimeout(() => {
          if (current < steps.length - 1) {
            show(current + 1);
            steps[current].querySelector('input')?.focus({ preventScroll: true });
          } else finish();
        }, 180);
      });
      back.addEventListener('click', () => show(Math.max(0, current - 1)));
      root.querySelector('[data-sv-conf-restart]').addEventListener('click', () => {
        form.reset();
        show(0);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      // Deep link from the teaser block: ?gebruik=particulier|professioneel skips step 1.
      const preset = new URLSearchParams(location.search).get("gebruik");
      const presetInput = preset ? form.querySelector(`input[name="use"][value="${CSS.escape(preset)}"]`) : null;
      if (presetInput) { presetInput.checked = true; show(1); } else show(0);
    };

    const run = () => document.querySelectorAll('[data-sv-conf]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Link columns: open on desktop (not foldable), folded on mobile.
    const mq = window.matchMedia('(max-width: 749px)');
    const sync = () => {
      document.querySelectorAll('[data-sv-fcol]').forEach((d) => {
        d.open = !mq.matches;
      });
    };
    document.addEventListener('click', (e) => {
      const summary = e.target.closest('[data-sv-fcol] > summary');
      if (summary && !mq.matches) e.preventDefault();
    });
    mq.addEventListener('change', sync);
    sync();
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-klusvinder"] && !Shopify.designMode) return;
  try {
    
  class SvKlusvinder extends HTMLElement {
    connectedCallback() {
      this.level = 2;
      this.labels = ['1 woonlaag', '2 woonlagen', '3 woonlagen', '4+ woonlagen'];
      this.advice = [...(this.querySelector('[data-advice]')?.content.querySelectorAll('span') ?? [])].map(
        (el) => el.textContent
      );
      this.cta = this.querySelector('[data-finder-cta]');
      this.addEventListener('change', this.update);
      this.querySelectorAll('[data-step]').forEach((btn) =>
        btn.addEventListener('click', () => {
          this.level = Math.min(4, Math.max(1, this.level + Number(btn.dataset.step)));
          this.update();
        })
      );
      this.update();
    }

    update = () => {
      const checked = this.querySelector('input[name="klus"]:checked');
      if (this.cta) this.cta.href = checked ? checked.value : this.dataset.defaultUrl;
      const label = this.querySelector('[data-height-label]');
      const advice = this.querySelector('[data-height-advice]');
      if (label) label.textContent = this.labels[this.level - 1];
      if (advice && this.advice[this.level - 1]) advice.textContent = this.advice[this.level - 1];
    };
  }
  if (!customElements.get('sv-klusvinder')) customElements.define('sv-klusvinder', SvKlusvinder);

  (() => {
    const parts = new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
    const minutes = Number(get('hour')) * 60 + Number(get('minute'));
    const weekend = ['za', 'zo'].some((d) => get('weekday').toLowerCase().startsWith(d));
    const open = !weekend && minutes >= 510 && minutes < 1050;
    document.querySelectorAll('[data-sv-hours]').forEach((el) => {
      el.dataset.open = String(open);
      el.textContent = open ? el.dataset.openLabel : el.dataset.closedLabel;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-main-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-sv-scroll-products]');
    if (!link) return;
    const target = document.getElementById('producten') || document.querySelector('[id$="__main"]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-comp-extras')) {
    customElements.define(
      'sv-comp-extras',
      class extends HTMLElement {
        connectedCallback() {
          this.vat = parseFloat(this.dataset.vat) || 121;
          this.money = new Intl.NumberFormat(this.dataset.locale || 'nl', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          });
          this.inputs = [...this.querySelectorAll('[data-comp-qty]')];
          if (!this.inputs.length) return;
          this.addEventListener('click', (e) => this.onStep(e));
          this.addEventListener('input', () => this.render());
          this.addEventListener('change', (e) => {
            if (e.target.matches('[data-comp-qty]')) this.clamp(e.target);
            this.render();
          });
          this.querySelector('[data-comp-add]')?.addEventListener('click', () => this.submitMainForm());
          /* Capture phase: runs before the product form's own submit handler */
          this.onSubmit = (e) => this.interceptSubmit(e);
          document.addEventListener('submit', this.onSubmit, true);
          this.render();
        }
        disconnectedCallback() {
          if (this.onSubmit) document.removeEventListener('submit', this.onSubmit, true);
        }
        clamp(input) {
          const v = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
          input.value = v;
          return v;
        }
        onStep(e) {
          const btn = e.target.closest('[data-step]');
          if (!btn || !this.contains(btn)) return;
          const input = btn.parentElement.querySelector('[data-comp-qty]');
          input.value = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.step, 10);
          this.clamp(input);
          this.render();
        }
        items() {
          return this.inputs
            .map((input) => ({
              id: parseInt(input.dataset.variantId, 10),
              quantity: Math.max(0, Math.min(99, parseInt(input.value, 10) || 0)),
              price: parseInt(input.dataset.price, 10) || 0,
            }))
            .filter((i) => i.quantity > 0);
        }
        render() {
          const items = this.items();
          const count = items.reduce((s, i) => s + i.quantity, 0);
          const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
          this.inputs.forEach((input) => input.closest('tr')?.classList.toggle('is-picked', (parseInt(input.value, 10) || 0) > 0));
          const summary = this.querySelector('[data-comp-summary]');
          if (!summary) return;
          summary.hidden = count === 0;
          const label = (count === 1 ? this.dataset.one : this.dataset.many) || '';
          this.querySelector('[data-comp-count]').textContent = label.replace('[count]', count);
          const excl = this.money.format(Math.round((total * 100) / this.vat) / 100);
          this.querySelector('[data-comp-total]').textContent = `${excl} excl. BTW`;
        }
        mainForm() {
          return [...document.querySelectorAll(`product-form-component[data-product-id="${this.dataset.productId}"] form`)].find(
            (f) => !this.contains(f)
          );
        }
        submitMainForm() {
          const form = this.mainForm();
          if (!form) return;
          const btn = form.querySelector('[type="submit"]');
          form.requestSubmit(btn || undefined);
        }
        async interceptSubmit(e) {
          if (this.bypass) return;
          const host = e.target.closest?.('product-form-component');
          if (!host || host.dataset.productId !== this.dataset.productId) return;
          const items = this.items().map(({ id, quantity }) => ({ id, quantity }));
          if (!items.length) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          const form = e.target;
          const submitter = e.submitter;
          const error = this.querySelector('[data-comp-error]');
          if (error) error.hidden = true;
          try {
            const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.description || data.message || 'Toevoegen mislukt');
            this.inputs.forEach((input) => (input.value = 0));
            this.render();
          } catch (err) {
            if (error) {
              error.textContent = err.message;
              error.hidden = false;
              error.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
            return;
          }
          /* Extras are in the cart: now let the theme add the product itself, which refreshes the cart drawer */
          this.bypass = true;
          try {
            form.requestSubmit(submitter && form.contains(submitter) ? submitter : undefined);
          } finally {
            this.bypass = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const field = document.querySelector('[data-sv-quote-products]');
    if (!field || field.value) return;
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    if (!product) return;
    const sku = params.get('sku');
    field.value = sku ? `${product} (art.nr. ${sku})` : product;
  })();
  if (document.querySelector('.sv-qform__success, .sv-qform__error')) {
    document.getElementById('offerte-formulier')?.scrollIntoView({ block: 'start' });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-refine"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sv-refine-quick]').forEach((form) => {
    form.addEventListener('submit', () => {
      // Leave out empty selects so the URL only carries chosen filters.
      form.querySelectorAll('[data-sv-refine-select]').forEach((s) => { s.disabled = !s.value; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-seo-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-faq-search')) {
    customElements.define(
      'sv-faq-search',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.list = document.getElementById(this.dataset.target);
          if (!this.input || !this.list) return;
          this.items = [...this.list.querySelectorAll('details')];
          this.empty = this.list.querySelector('[data-faq-empty]');
          this.input.addEventListener('input', () => this.filter());
        }
        filter() {
          const q = this.input.value.trim().toLowerCase();
          let shown = 0;
          this.items.forEach((item) => {
            const match = !q || item.textContent.toLowerCase().includes(q);
            item.hidden = !match;
            if (match) shown++;
            if (q && match && shown === 1) item.open = true;
          });
          if (this.empty) this.empty.hidden = shown > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-subcat-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-subcat-explorer')) {
    customElements.define(
      'sv-subcat-explorer',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[data-sx-tab]')];
          this.panels = [...this.querySelectorAll('[data-sx-panel]')];
          this.tabs.forEach((tab, i) => {
            const id = `${this.closest('.shopify-section')?.id || 'sx'}-tab-${i}`;
            tab.id = id;
            this.panels[i]?.setAttribute('aria-labelledby', id);
            tab.setAttribute('aria-controls', (this.panels[i].id = `${id}-panel`));
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              e.preventDefault();
              const n = this.tabs.length;
              this.select((i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n, true);
            });
          });
          /* Open the group that contains the current collection, else the first */
          const current = this.querySelector('[aria-current="page"]');
          const start = current ? Math.max(0, this.panels.indexOf(current.closest('[data-sx-panel]'))) : 0;
          this.select(start);
        }
        select(index, focus = false) {
          this.tabs.forEach((t, i) => {
            const on = i === index;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            if (on && focus) t.focus();
            if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
          this.panels.forEach((p, i) => (p.hidden = i !== index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-support"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const esc = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    // FAQ search: filters questions, hides empty groups, shows a contact fallback.
    const initSearch = (root) => {
      const input = root.querySelector('[data-sv-sup-search]');
      const faq = root.querySelector('[data-sv-sup-faq]');
      if (!input || !faq) return;
      const empty = faq.querySelector('[data-sv-sup-empty]');
      let scrolled = false;
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        let hits = 0;
        faq.querySelectorAll('[data-sv-sup-group]').forEach((g) => {
          let groupHits = 0;
          g.querySelectorAll('[data-sv-sup-q]').forEach((d) => {
            const match = !q || d.textContent.toLowerCase().includes(q);
            d.hidden = !match;
            d.open = Boolean(q) && match && groupHits === 0 && hits === 0;
            if (match) groupHits += 1;
          });
          g.hidden = groupHits === 0;
          hits += groupHits;
        });
        if (empty) empty.hidden = hits > 0;
        if (q && !scrolled) {
          faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
          scrolled = true;
        }
        if (!q) scrolled = false;
      });
    };

    // Guided help assistant.
    const initBot = (root) => {
      const bot = root.querySelector('[data-sv-bot]');
      const dataEl = root.querySelector('[data-sv-bot-data]');
      if (!bot || !dataEl) return;
      let data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const log = bot.querySelector('[data-sv-bot-log]');
      const actions = bot.querySelector('[data-sv-bot-actions]');

      const say = (html, who = 'bot') => {
        const el = document.createElement('div');
        el.className = `sv-sup__bot-msg sv-sup__bot-msg--${who}`;
        el.innerHTML = html;
        log.appendChild(el);
        log.scrollTop = log.scrollHeight;
      };
      const options = (list) => {
        actions.innerHTML = '';
        list.forEach((o) => {
          const el = document.createElement(o.href ? 'a' : 'button');
          el.className = `sv-sup__bot-opt${o.primary ? ' is-primary' : ''}`;
          el.textContent = o.label;
          if (o.href) {
            el.href = o.href;
            if (o.chat) el.setAttribute('data-sv-chat', '');
          } else {
            el.type = 'button';
            el.addEventListener('click', () => {
              say(esc(o.label), 'user');
              o.go();
            });
          }
          actions.appendChild(el);
        });
      };

      const c = data.contact || {};
      const contactOptions = () => {
        const list = [];
        if (c.phone) list.push({ label: `Bel ${c.phone}`, href: c.phoneHref, primary: true });
        if (c.wa) list.push({ label: 'WhatsApp', href: c.wa });
        if (c.chat) list.push({ label: c.chat, href: '#contactformulier', chat: true });
        if (c.email) list.push({ label: 'Mail ons', href: `mailto:${c.email}` });
        list.push({ label: 'Stuur een bericht', href: '#contactformulier' });
        list.push({ label: '← Terug naar het begin', go: start });
        return list;
      };
      const human = () => {
        say('Geen probleem, onze specialisten helpen je graag persoonlijk. Kies hoe je contact wilt opnemen:');
        options(contactOptions());
      };
      const feedback = () => {
        options([
          { label: 'Ja, bedankt!', go: () => { say('Fijn! Kan ik je nog ergens anders mee helpen?'); options(menu()); } },
          { label: 'Nee, ik wil iemand spreken', go: human },
          { label: '← Andere vraag', go: start },
        ]);
      };

      const showTopic = (key, title) => {
        const list = (data.faqs || []).filter((f) => f.topic === key);
        say(`Dit zijn de meest gestelde vragen over <strong>${esc(title.toLowerCase())}</strong>:`);
        options([
          ...list.map((f) => ({ label: f.q, go: () => { say(f.a || ''); setTimeout(() => say('Heeft dit je geholpen?'), 300); feedback(); } })),
          { label: 'Mijn vraag staat er niet bij', go: human },
          { label: '← Terug', go: start },
        ]);
      };

      const advice = (type) => {
        const url = (data.advisor || {})[type];
        if (type === 'ladder' || type === 'trap') {
          const word = type === 'ladder' ? 'ladder' : 'trap';
          say(`Bij elke ${word} staat de <strong>reikhoogte</strong>: zo hoog kun je ongeveer werken. Kies een ${word} met een reikhoogte die minimaal gelijk is aan je hoogste werkpunt. Twijfel je over de juiste lengte of uitvoering? Dan denken we graag even mee.`);
          options([
            ...(url ? [{ label: `Bekijk ${word === 'ladder' ? 'ladders' : 'trappen'}`, href: url, primary: true }] : []),
            { label: 'Advies van een specialist', go: human },
            { label: '← Opnieuw', go: start },
          ]);
          return;
        }
        say('Hoe hoog is het <strong>hoogste punt</strong> waar je moet werken? Bijvoorbeeld de dakgoot of het plafond. Vul het aantal meters in.');
        actions.innerHTML = '';
        const form = document.createElement('form');
        form.className = 'sv-sup__bot-form';
        form.innerHTML = '<label class="visually-hidden" for="sv-bot-h">Hoogte in meters</label><input id="sv-bot-h" type="number" inputmode="decimal" min="1" max="20" step="0.1" placeholder="Bijv. 6,5" required><span>meter</span><button type="submit" class="sv-sup__bot-opt is-primary">Bereken</button>';
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const h = parseFloat(form.querySelector('input').value.replace(',', '.'));
          if (!h || h <= 0) return;
          say(`${esc(String(h).replace('.', ','))} meter`, 'user');
          const wh = Math.ceil(h * 2) / 2;
          const platform = Math.max(wh - 2, 0);
          const nl = (n) => n.toFixed(1).replace('.', ',').replace(',0', '');
          const kind = type === 'kamersteiger' ? 'kamersteiger' : 'rolsteiger';
          let msg = `Kies een ${kind} met een <strong>werkhoogte van minimaal ${nl(wh)} m</strong>. Het platform staat dan op ongeveer ${nl(platform)} m, zodat je comfortabel op werkhoogte staat.`;
          if (type === 'kamersteiger' && wh > 5) msg += ' Voor deze hoogte kom je al snel uit bij een rolsteiger.';
          say(msg);
          options([
            ...(url ? [{ label: `Bekijk ${kind}s`, href: url, primary: true }] : []),
            ...(type === 'kamersteiger' && wh > 5 && data.advisor.rolsteiger ? [{ label: 'Bekijk rolsteigers', href: data.advisor.rolsteiger }] : []),
            ...(c.quote ? [{ label: 'Gratis offerte op maat', href: c.quote }] : []),
            { label: 'Advies van een specialist', go: human },
            { label: '← Opnieuw', go: start },
          ]);
        });
        actions.appendChild(form);
        form.querySelector('input').focus({ preventScroll: true });
      };

      const advisor = () => {
        say('Wat ga je doen?');
        options([
          { label: 'Buiten op hoogte werken (gevel, dakgoot, kozijnen)', go: () => advice('rolsteiger') },
          { label: 'Binnen werken (plafond, trappenhuis)', go: () => advice('kamersteiger') },
          { label: 'Kort klusje, snel op en af', go: () => advice('ladder') },
          { label: 'Stabiel staan op lage hoogte', go: () => advice('trap') },
          { label: '← Terug', go: start },
        ]);
      };

      const menu = () => [
        { label: 'Welke steiger of ladder heb ik nodig?', go: advisor, primary: true },
        ...(data.topics || []).filter((t) => (data.faqs || []).some((f) => f.topic === t.key)).map((t) => ({ label: t.title, go: () => showTopic(t.key, t.title) })),
        { label: 'Ik wil iemand spreken', go: human },
      ];

      function start() {
        say(data.welcome || 'Waar kan ik je mee helpen?');
        options(menu());
      }

      bot.querySelector('[data-sv-bot-reset]')?.addEventListener('click', () => {
        log.innerHTML = '';
        start();
      });
      start();
    };

    const init = () => document.querySelectorAll('[data-sv-support]').forEach((root) => {
      if (root.dataset.svReady) return;
      root.dataset.svReady = '1';
      initSearch(root);
      initBot(root);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-usp-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Phone buttons (header + footer): show "Nu bereikbaar" with a green dot during opening hours,
    // weekdays 08:30-17:30 Dutch time; otherwise keep the opening hours text.
    const update = () => {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
      }).formatToParts(new Date());
      const get = (t) => parts.find((p) => p.type === t)?.value;
      const minutes = Number(get('hour')) * 60 + Number(get('minute'));
      const open = !['Sat', 'Sun'].includes(get('weekday')) && minutes >= 510 && minutes < 1050;
      document.querySelectorAll('[data-sv-open-status]').forEach((el) => {
        el.classList.toggle('is-open', open);
        const label = el.querySelector('[data-sv-open-label]');
        if (label) label.textContent = open ? label.dataset.open : label.dataset.closed;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
    else update();
    setInterval(update, 60000);
  })();

  (() => {
    const mq = window.matchMedia('(max-width: 749px)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-sv-usp-rotate]').forEach((list) => {
      const items = [...list.children];
      if (items.length < 2) return;
      let i = 0;
      let timer;
      const show = () => items.forEach((li, n) => li.classList.toggle('is-active', n === i));
      const start = () => {
        clearInterval(timer);
        const on = mq.matches && !reduce.matches;
        list.toggleAttribute('data-rotating', on);
        if (!on) return;
        show();
        timer = setInterval(() => { i = (i + 1) % items.length; show(); }, 4000);
      };
      mq.addEventListener('change', start);
      reduce.addEventListener('change', start);
      start();
    });
  })();

  (() => {
    // Chat buttons in the menu: open Shopify Inbox or another chat widget; otherwise follow the link.
    const openChat = () => {
      const inbox = document.querySelector('inbox-online-store-chat');
      const inboxBtn = inbox?.shadowRoot?.querySelector('button');
      if (inboxBtn) { inboxBtn.click(); return true; }
      if (window.tidioChatApi) { window.tidioChatApi.open(); return true; }
      if (window.$crisp) { window.$crisp.push(['do', 'chat:open']); return true; }
      if (window.Tawk_API?.maximize) { window.Tawk_API.maximize(); return true; }
      if (window.zE) { window.zE('messenger', 'open'); return true; }
      return false;
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-sv-chat]');
      if (!btn || !openChat()) return;
      e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
